import {combineReducers} from "redux";
import {routerReducer} from "react-router-redux";
import {storeItemsListReducer} from "./store/storeItemsListReducer";
import {loginReducer} from "./login/loginReducer";
import {storeCategoriesReducer} from "./store/storeCategoriesReducer";
import {storeOrderStatusReducer} from "./store/storeOrderStatusReducer";
import {summaryReducer} from "./common/summaryReducer";
import {messageReducer} from "./common/messageReducer";
import {gaReducer} from "./common/gaReducer";
import {joinReducer} from "./join/joinReducer";
import {staticDataReducer} from "./common/staticDataReducer";
import {storeCheckoutReducer} from "./store/storeCheckoutReducer";
import {storeCreditsReducer} from "./store/storeCreditsReducer";
import {accountReducer} from "./account/accountReducer";
import {storageReducer} from "./common/storageReducer";
import {memberReducer} from "./login/memberReducer";
import {fetchingReducer} from "./common/fetchingReducer";
import {clientViewPortReducer} from "./common/clientViewPortReducer";
import {logRocketReducer} from "./common/logRocketReducer";
import {storeRecurringOrderReducer} from "./store/storeRecurringOrderReducer";

const reducers =
    combineReducers({
        routing: routerReducer,
        itemsList: storeItemsListReducer,
        loginStatus: loginReducer,
        categories: storeCategoriesReducer,
        orderStatus: storeOrderStatusReducer,
        summary: summaryReducer,
        messageData: messageReducer,
        gaReducer: gaReducer,
        signupData: joinReducer,
        staticData: staticDataReducer,
        checkout: storeCheckoutReducer,
        storeCreditsData: storeCreditsReducer,
        account: accountReducer,
        recurringOrder: storeRecurringOrderReducer,
        storage: storageReducer,
        memberDetails: memberReducer,
        fetching: fetchingReducer,
        clientViewPort: clientViewPortReducer,
        logRocket: logRocketReducer
    });

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js